module.exports = __webpack_public_path__ + "ec3607e38775944afea0e9e8f06a98bc.png";